import { reactive } from '@vue/composition-api';
import { useQuery } from 'vue-query';
import { getCartItemList } from '@/api/orderSend/orderSend';

import { useUserInfo } from '@/utils/hooks';

export default function useCartListAPI({ onSuccess } = {}) {
  const queryKey = reactive(['cart', {}]);
  const { isLoggedIn } = useUserInfo();

  const fetchList = async ({}) => {
    const response = await getCartItemList({});

    const { code, message, result } = response;

    if (code !== 'SUC0000') {
      throw new Error(`${code}: ${message}`);
    }

    return result;
  };

  const options = reactive({
    enabled: isLoggedIn,
    initialData: {
      resultList: [],
      totalCount: 0,
    },
    refetchOnWindowFocus: true,
    onSuccess,
  });

  return useQuery(queryKey, fetchList, options);
}
